import {CardActionArea, Divider, IconButton, Stack, Typography} from '@mui/material';
import {AddWhite, Alert} from '@icons/index';
import {Colors} from '@constants/colors.constants';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {IssueLight} from '@store/operations/issues';
import {useSnackbar} from 'notistack';
import {executionsService} from '@store/operations/executions';

interface IssueFormProps {
  executionId: number;
  readOnly?: boolean;
}

const IssueForm = (props: IssueFormProps) => {
  const {executionId, readOnly} = props;

  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const navigate = useNavigate();

  const [issues, setIssues] = useState<IssueLight[]>([]);

  useEffect(() => {
    if (executionId) {
      executionsService.getExecutionIssues(executionId).subscribe({
        next: setIssues,
        error: (err) => enqueueSnackbar(err.text, err.options),
      });
    }
  }, [enqueueSnackbar, executionId]);

  return (
    <>
      <Stack py="20px" spacing={2}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography fontSize={16} fontWeight="700">
            {t('operations.executions.manage.noncompliance')}
          </Typography>
          {!readOnly && (
            <IconButton
              aria-label="small-square-text"
              centerRipple={false}
              onClick={() => navigate(`../${executionId}/add`)}>
              <AddWhite/>
            </IconButton>
          )}
        </Stack>
        <Stack spacing={1.5}>
          {issues.map((issue) => (
            <CardActionArea
              key={issue.id}
              aria-label="noncompliance"
              disableRipple
              onClick={() => navigate(`../${executionId}/issue/${issue.id}`)}>
              <Stack direction="row" alignItems="center" spacing={1.5}>
                <Alert/>
                <Stack>
                  <Typography fontSize={14} fontWeight="700" mb="-1.5px">
                    {issue.issueSignature}
                  </Typography>
                  <Typography fontSize={9} fontWeight="400" color={Colors.textWithOpacity}>
                    {issue.author ? t('global.createdByAt', {
                      by: {
                        firstName: issue.author?.firstName,
                        lastName: issue.author?.lastName[0],
                      },
                      at: new Date(issue.reportedAt),
                    }) : t('global.createdAt', {
                      at: new Date(issue.reportedAt),
                    })}
                  </Typography>
                </Stack>
              </Stack>
            </CardActionArea>
          ))}
        </Stack>
      </Stack>
      <Divider variant="fullWidth" orientation="horizontal"/>
    </>
  );
};

export default IssueForm;
